import React from 'react'
import './BtnWrapper.css'

const BtnWrapper = props => {
  return (
    <div className={`btn-wrapper ${props.className}`}>{props.children}</div>
  )
}

export default BtnWrapper